// import ChessRestClient from "../Api/ChessRestClient";
// import { getLocalStorage } from "../Utils/CommonUtils";
import useChatRestClient from '@/Api/ChatRestClient';
import {useMutation} from '@tanstack/react-query';

type fetchTournamentEligibilityProps = {
  mobile_number: string;
  player_id: number;
  registration_tid: number;
};

export default function useFetchTournamentEligibility() {
  const ChatRestClient = useChatRestClient();
  const mutation = useMutation(
    async (data: fetchTournamentEligibilityProps) => {
      // TODO: remove the comment
      const response = await ChatRestClient.post(
        '/v1/fetch_player_eligibility_for_tournament',
        data,
      );
      return response.data;
    },
  );

  return {
    ...mutation,
    isLoading: mutation.isLoading,
  };
}
